import { useQuery } from '@tanstack/react-query';
import {
  getCycleTimeReport,
  getHoursReport,
  getOverdueReport,
  getOverrunsReport,
  getOverviewReport,
  getThroughputReport,
  getWorkloadReport,
  type ReportFilters,
  type ThroughputBucket,
} from '../lib/taskReportsApi';

// One query per report section so each card/section shows its own spinner and
// refetches independently when the shared filters change.

export function useOverviewReport(filters: ReportFilters) {
  return useQuery({
    queryKey: ['task-reports', 'overview', filters],
    queryFn: () => getOverviewReport(filters),
  });
}

export function useHoursReport(filters: ReportFilters) {
  return useQuery({
    queryKey: ['task-reports', 'hours', filters],
    queryFn: () => getHoursReport(filters),
  });
}

export function useOverrunsReport(filters: ReportFilters) {
  return useQuery({
    queryKey: ['task-reports', 'overruns', filters],
    queryFn: () => getOverrunsReport(filters),
  });
}

export function useThroughputReport(filters: ReportFilters, bucket: ThroughputBucket) {
  return useQuery({
    queryKey: ['task-reports', 'throughput', filters, bucket],
    queryFn: () => getThroughputReport(filters, bucket),
  });
}

export function useCycleTimeReport(filters: ReportFilters) {
  return useQuery({
    queryKey: ['task-reports', 'cycle-time', filters],
    queryFn: () => getCycleTimeReport(filters),
  });
}

export function useWorkloadReport(filters: ReportFilters) {
  return useQuery({
    queryKey: ['task-reports', 'workload', filters],
    queryFn: () => getWorkloadReport(filters),
  });
}

export function useOverdueReport(filters: ReportFilters) {
  return useQuery({
    queryKey: ['task-reports', 'overdue', filters],
    queryFn: () => getOverdueReport(filters),
  });
}
